import { errorNotification } from "Components/MyNotification";
import WorksApi from "./WorksApi";

export const getAllWorksToSelect = async (search, projectId = "") => {
  try {
    const result = await WorksApi.getAllWorks(1, search, projectId);

    // {
    //   code:'',
    //   code_norm:'',
    //   id:'',
    //   title:'',
    //   unit:'',
    //   materialsForWork:[]
    // }

    if (result.status === "success") {
      if (projectId) {
        return result.dto.map((item) => ({
          label: item.code + " " + item.title + ", " + item.unit,
          value:
            JSON.stringify({
              value: 0,
              // code: item.workType.code,
              // unit: item.workType.unit,
              // allowedWorkTypeId: item.id,
              // title: item.workType.title,
              code: item.code,
              unit: item.unit,
              allowedWorkTypeId: item.id,
              title: item.title,
              materialsForWork: item.materialsForWork
                ? item.materialsForWork.map((el) => {
                    return {
                      id: el.id,
                      value: 0,
                      nomenclature: el.nomenclature,
                      unit: el.unit,
                      dateArrived: el.dateArrived,
                      restCount: el.restCount,
                      restCountAfterChanges: el.restCount,
                      workTypeTied: null,
                    };
                  })
                : null,
            }) +
            "___" +
            item.id,
        }));
      }

      return result.dto.data.map((item) => ({
        label: item.code + " " + item.title,
        value:
          JSON.stringify({
            // value: 0,
            id: item.id,
            code: item.code,
            unit: item.unit,
            title: item.title,
            // allowedWorkTypeId: item.id,
          }) +
          "___" +
          item.id,
      }));
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};
